import { ApiHeaders } from "./Helper"
import { resolve } from "./Resolver"
import helper from "./Helper"
import axios from "axios"

const ApiCall = async (method, url, data = null, token = null, isExternel = false, signal = null) => {
    return await resolve(
        axios({
            method: method,
            url: isExternel ? url : helper.ApiUrl + url,
            headers: ApiHeaders(token),
            data: data,
            signal
        })
            .then(response => response.data)
            .catch(error => error.response.data)
    )

}

export default ApiCall